// extracted by mini-css-extract-plugin
export var container = "_9h-0";
export var icon = "_9h-1";
export var text = "_9h-2";